import { clsx } from 'clsx';

import { useWidget } from '../../context/WidgetContext';
import { useWidgetEditorArea } from '../../hooks/useWidgetEditorArea';

import { WidgetEditor } from '../WidgetEditor';
import { WidgetLock } from '../WidgetLock';

import styles from './styles.module.css';

export const WidgetEditorArea = () => {
  const { messages } = useWidget();
  const { editorLock, unlockEditor, onSubmit } = useWidgetEditorArea();

  return (
    <div
      className={clsx({
        [styles.widgetEditorAbsolute]: messages.length === 0,
      })}
    >
      {editorLock ? (
        <WidgetLock type={editorLock} onStartNewDialog={unlockEditor} />
      ) : (
        <WidgetEditor onSubmit={onSubmit} />
      )}
    </div>
  );
};
